import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, Navigate } from 'react-router-dom';
import { deleteAgentBlackList } from "../../redux/modules/agents";
import Layout from "../layout"
import PopupMsg from "../common/popup-msg"
import { closeErrorMsg } from "../../redux/modules/agents";

const DeleteBlacklist = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const auth = useSelector(state => state.auth);
  const agents = useSelector(state => state.agents);

  const handleDeleteBlackList = (e) => {
    e.preventDefault();    

    dispatch(
      deleteAgentBlackList({
        cmd: 'agents-blacklist',
        id: location.state.id,
        action: 2,
        _debug_token: auth.token
      })
    )
  }

  if(agents.action) return <Navigate to='/agents-list' replace />

  return (    
    <Layout>
      <div className="action-block">
        <div className="action-block__wrap">
          <div className="action-block__title">Удаление из черного списка</div>      
          <div className="action-block__text">Вы уверены, что хотите удалить пользователя <b>{location.state.fio}</b> из черного списка?</div>      
          <div className="action-block__buttons">
            <Link to="/agents-list" className="btn">оставить в черном списке</Link>
            <button type="button" className="btn btn_empty" onClick={handleDeleteBlackList}>сделать активным</button>
          </div>
        </div>
      </div>
      {agents.error && <PopupMsg message={agents.error} close={closeErrorMsg()} />}
    </Layout>
  )
}

export default DeleteBlacklist